/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import {
  Segment, Form,
  Divider, Button, Dimmer,
  Loader, Input, Grid,
  Container, Checkbox,
} from "semantic-ui-react";

import { withRouter } from "react-router-dom";

import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

export class OpticFiberConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      signalActiveFB1: false,
      channel2ActiveFB1: false,
      channel3ActiveFB1: false,
      signalActiveFB2: false,
      channel2ActiveFB2: false,
      channel3ActiveFB2: false,
      // Limites
      fiberLowerLimitUrgentMaintenance: "",
      fiberLowerLimitMaintenanceRequired: "",
      //
      channel2FB1: "",
      channel3FB1: "",
      signalFB1: "",
      channel2FB2: "",
      channel3FB2: "",
      signalFB2: "",
      // Dimmers
      isFiberChannelActiveDimmerActive: false,
      isIntervalsDimmerActive: false,
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/isFiberProcessOn", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/fiberChannelActive", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/fiberLimit", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      isFiberProcessOn: resolvedPromisses[0].isFiberProcessOn,
      //
      signalActiveFB1: resolvedPromisses[1].FB1.signalActive,
      channel2ActiveFB1: resolvedPromisses[1].FB1.channel2Active,
      channel3ActiveFB1: resolvedPromisses[1].FB1.channel3Active,
      signalActiveFB2: resolvedPromisses[1].FB2.signalActive,
      channel2ActiveFB2: resolvedPromisses[1].FB2.channel2Active,
      channel3ActiveFB2: resolvedPromisses[1].FB2.channel3Active,
      // Limites
      fiberLowerLimitUrgentMaintenance: resolvedPromisses[2].fiberLowerLimitUrgentMaintenance,
      fiberLowerLimitMaintenanceRequired: resolvedPromisses[2].fiberLowerLimitMaintenanceRequired,
    });
  }

  handlefiberLowerLimitUrgentMaintenanceChange = (e, { value }) => {
    this.setState({ fiberLowerLimitUrgentMaintenance: value });
  }

  handlefiberLowerLimitMaintenanceRequiredChange = (e, { value }) => {
    this.setState({ fiberLowerLimitMaintenanceRequired: value });
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSignalActiveChangeFB1 = () => this.setState({ signalActiveFB1: !this.state.signalActiveFB1 });
  handleFiberChannel2ChangeFB1 = () => this.setState({ channel2ActiveFB1: !this.state.channel2ActiveFB1 });
  handleFiberChannel3ChangeFB1 = () => this.setState({ channel3ActiveFB1: !this.state.channel3ActiveFB1 });
  handleSignalActiveChangeFB2 = () => this.setState({ signalActiveFB2: !this.state.signalActiveFB2 });
  handleFiberChannel2ChangeFB2 = () => this.setState({ channel2ActiveFB2: !this.state.channel2ActiveFB2 });
  handleFiberChannel3ChangeFB2 = () => this.setState({ channel3ActiveFB2: !this.state.channel3ActiveFB2 });

  handleFiberChannelActiveSubmit = () => {
    this.setState({ isFiberChannelActiveDimmerActive: true }, () => {
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/fiberChannelActive_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({
          FB1: {
            signalActive: this.state.signalActiveFB1,
            channel2Active: this.state.channel2ActiveFB1,
            channel3Active: this.state.channel3ActiveFB1,
          },
          FB2: {
            signalActive: this.state.signalActiveFB2,
            channel2Active: this.state.channel2ActiveFB2,
            channel3Active: this.state.channel3ActiveFB2,
          }
        }),
        mode: "cors"
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.SEND_CONFIG_SUCCESS);
          this.retrieveData();
        })
        .catch((error) => {
          alert(Strings.SEND_CONFIG_FAILURE + Strings.ERROR_REASON + error);
        })
        .finally(() => {
          this.setState({ isFiberChannelActiveDimmerActive: false });
        });
    });
  }

  handleIntervalsSubmit = () => {
    const isValidNumber1 = Number.isFinite(parseFloat(this.state.fiberLowerLimitUrgentMaintenance));
    const isValidNumber2 = Number.isFinite(parseFloat(this.state.fiberLowerLimitMaintenanceRequired));

    if (isValidNumber1 && isValidNumber2) {

      if (this.state.fiberLowerLimitMaintenanceRequired > this.state.fiberLowerLimitUrgentMaintenance) {
        this.setState({ isIntervalsDimmerActive: true }, () => {

          fetch(Constants.REQUEST_IP_ADDRESS + "fiber/fiberLimit_POST", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            },
            body: JSON.stringify({
              fiberLowerLimitMaintenanceRequired: this.state.fiberLowerLimitMaintenanceRequired,
              fiberLowerLimitUrgentMaintenance: this.state.fiberLowerLimitUrgentMaintenance
            }),
            mode: "cors"
          })
            .then(UtilsInstance.checkStatus)
            .then(() => {
              alert(Strings.SEND_CONFIG_SUCCESS);
              this.retrieveData();
            })
            .catch((error) => {
              alert(Strings.SEND_CONFIG_FAILURE + Strings.ERROR_REASON + error);
            })
            .finally(() => {
              this.setState({ isIntervalsDimmerActive: false });
            });

        });
      }
      else {
        alert(Strings.DIVERGENCE_MAINTENANCE_VALUE);
      }
    }
    else {
      alert(Strings.INVALID_VALUE);
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    return (
      <Container>
        <Grid columns={2}>
          <Grid.Column>

            <Segment>

              <Form style={formStyle} onSubmit={this.handleFiberChannelActiveSubmit}>
                <Segment>
                  <Divider horizontal>
                    {Strings.OPTIC_FIBER + " 1"}
                  </Divider>

                  <Divider horizontal>
                    {Strings.RELAY}
                  </Divider>

                  <Form.Field>
                    <Checkbox
                      toggle
                      name="signalActiveFB1"
                      onClick={this.handleSignalActiveChangeFB1}
                      checked={this.state.signalActiveFB1}
                      label={Strings.RELAY_SIGNAL}/>
                  </Form.Field>

                  <Divider horizontal style={channelsDividerStyle}>
                    {Strings.CHANNELS}
                  </Divider>

                  <Form.Group widths="equal">
                    <Form.Field style={{ marginRight: "1.5vw" }}>
                      <Checkbox
                        toggle
                        name="channel2ActiveFB1"
                        onClick={this.handleFiberChannel2ChangeFB1}
                        checked={this.state.channel2ActiveFB1}
                        label={Strings.CHANNEL_2} />
                    </Form.Field>

                    <Form.Field style={{ marginRight: "1.5vw" }}>
                      <Checkbox
                        toggle
                        name="channel3ActiveFB1"
                        onClick={this.handleFiberChannel3ChangeFB1}
                        checked={this.state.channel3ActiveFB1}
                        label={Strings.CHANNEL_3} />
                    </Form.Field>
                  </Form.Group>
                </Segment>
                <Segment>
                  <Divider horizontal>
                    {Strings.OPTIC_FIBER + " 2"}
                  </Divider>

                  <Divider horizontal>
                    {Strings.RELAY}
                  </Divider>
                  <Form.Field>
                    <Checkbox
                      toggle
                      name="signalActiveFB2"
                      onClick={this.handleSignalActiveChangeFB2}
                      checked={this.state.signalActiveFB2}
                      label={Strings.RELAY_SIGNAL} />
                  </Form.Field>

                  <Divider horizontal style={channelsDividerStyle}>
                    {Strings.CHANNELS}
                  </Divider>

                  <Form.Group widths="equal">
                    <Form.Field style={{ marginRight: "1.5vw" }}>
                      <Checkbox
                        toggle
                        name="channel2ActiveFB2"
                        onClick={this.handleFiberChannel2ChangeFB2}
                        checked={this.state.channel2ActiveFB2}
                        label={Strings.CHANNEL_2} />
                    </Form.Field>

                    <Form.Field style={{ marginRight: "1.5vw" }}>
                      <Checkbox
                        toggle
                        name="channel3ActiveFB2"
                        onClick={this.handleFiberChannel3ChangeFB2}
                        checked={this.state.channel3ActiveFB2}
                        label={Strings.CHANNEL_3} />
                    </Form.Field>
                  </Form.Group>
                </Segment>

                <Button color="teal" type="submit" >{Strings.SETUP}</Button>

              </Form>

              <Dimmer active={this.state.isFiberChannelActiveDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>

          </Grid.Column>

          <Grid.Column>

            <Segment textAlign="center">
              <Divider horizontal>
                {Strings.MAINTENANCE_REQUIRED}
              </Divider>

              <Form style={formStyle} onSubmit={this.handleIntervalsSubmit}>

                <Form.Field inline>
                  <label>{Strings.STR_LIMIT}</label>
                  <Input
                    name="fiberLowerLimitMaintenanceRequired"
                    type="number"
                    placeholder='0.3'
                    label={{ basic: true, content: "V" }}
                    labelPosition='right'
                    value={this.state.fiberLowerLimitMaintenanceRequired}
                    onChange={this.handleChange} />
                </Form.Field>

                <Button color="teal" type="submit" >{Strings.SETUP}</Button>

              </Form>

              <Dimmer active={this.state.isIntervalsDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Segment textAlign="center">
              <Divider horizontal>
                {Strings.MAINTENANCE_URGENT}
              </Divider>

              <Form style={formStyle} onSubmit={this.handleIntervalsSubmit}>

                <Form.Field inline>
                  <label>{Strings.STR_LIMIT}</label>
                  <Input
                    name="fiberLowerLimitUrgentMaintenance"
                    type="number"
                    placeholder='0.1'
                    label={{ basic: true, content: "V" }}
                    labelPosition='right'
                    value={this.state.fiberLowerLimitUrgentMaintenance}
                    onChange={this.handleChange} />
                </Form.Field>

                <Button color="teal" type="submit" >{Strings.SETUP}</Button>

              </Form>

              <Dimmer active={this.state.isIntervalsDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>

          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const channelsDividerStyle = {
  marginTop: "3vh",
};

export default withRouter(OpticFiberConfig);